import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { Col, Container, Row } from "react-bootstrap";

import { firestore } from "../../firebase";
import ProductCard from "../../components/ProductCard";
import CardFooter from "../../components/ProductCard/CardFooter";
import Header from "../../components/Header";
import Footer from '../../components/Footer';


const Products = () => {
    const [products, setProducts] = useState([]);
    const productsCollectionRef = collection(firestore, 'produtos')


    useEffect(() => {
        const getProducts = async () => {
            const data = await getDocs(productsCollectionRef);
            setProducts(data.docs.map((doc) => ({ ...doc.data() })))
        }

        getProducts()
    }, [])

    return (
        <>
            <Header />
            <Container>
                <h1 className="display-4">Produtos disponíveis para compra</h1>
                <Row>
                    
                        {products.map((product) => {
                            if(product.price > 0) return <Col sm={4}> <ProductCard header={product.name} 
                                                            img={product.thumbnail}
                                                            footer={<CardFooter
                                                            price={product.price} />}
                                                            store={product.link} /> </Col>
                        })}
                    
                </Row>
            </Container>
            <Footer />
        </>
    )
}


export default Products;
//TODO: DRY